export default {
  functionKey: "EXTRAIRE",
  title: "EXTRAIRE",
  group: "Parsing",
  origin: [],
  target: [],
  arguments: [],
  showTypeOptions: { origin: false, target: false, arguments: false },
  maxArguments: 1,
  minArguments: 1,
  expectedArguments: [
    { name: "date",      autoFill: "date",      single: true },
    { name: "année",     autoFill: "année",     single: true },
    { name: "mois",      autoFill: "mois",      single: true },
    { name: "jour",      autoFill: "jour",      single: true },
    { name: "heure",     autoFill: "heure",     single: true },
    { name: "nombre",    autoFill: "nombre",    single: true },
    { name: "email",     autoFill: "email",     single: true },
    { name: "URL",       autoFill: "URL",       single: true },
    { name: "SIREN",     autoFill: "SIREN",     single: true },
    { name: "SIRET",     autoFill: "SIRET",     single: true },
    { name: "téléphone", autoFill: "téléphone", single: true },
    { name: "prix",      autoFill: "prix",      single: true }
  ],
  description: "Extraire date|année|mois|jour|heure|nombre|email|URL|SIREN|SIRET|téléphone|prix d'un texte",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    let displayCode = "";
    let safeCode = "";

    if (args[0] === undefined) return { displayCode, safeCode };

    if (isArgumentCol[0] === false) {
      const searchType = args[0].replace(/'/g, "");
      switch (searchType) {
        case "date":
          safeCode    = `${destination} = ${origin}.match(/\\b\\d{2}[/-]\\d{2}[/-]\\d{4}\\b/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\b\\d{2}[/-]\\d{2}[/-]\\d{4}\\b/g);`;
          break;
        case "année":
          safeCode    = `${destination} = ${origin}.match(/\\d{4}/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\d{4}/g)[0];`;
          break;
        case "mois":
          safeCode    = `${destination} = ${origin}.match(/\\d{2}/g)?.[1] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\d{2}/g)[1];`;
          break;
        case "jour":
          safeCode    = `${destination} = ${origin}.match(/\\d{2}/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\d{2}/g)[0];`;
          break;
        case "heure":
          safeCode    = `${destination} = ${origin}.match(/\\d{2}/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\d{2}/g)[0];`;
          break;
        case "nombre":
          safeCode    = `${destination} = ${origin}.match(/\\d+/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\d+/g)[0];`;
          break;
        case "email":
          safeCode    = `${destination} = ${origin}.match(/\\S+@\\S+/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\S+@\\S+/g)[0];`;
          break;
        case "URL":
          safeCode    = `${destination} = ${origin}.match(/\\S+:\\/\\/\\S+\\.\\S+/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\S+:\\/\\/\\S+\\.\\S+/g)[0];`;
          break;
        case "SIREN":
          safeCode    = `${destination} = ${origin}.match(/\\b\\d{9}\\b/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\b\\d{9}\\b/g)[0];`;
          break;
        case "SIRET":
          safeCode    = `${destination} = ${origin}.match(/\\b\\d{14}\\b/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/\\b\\d{14}\\b/g)[0];`;
          break;
        case "téléphone":
          safeCode    = `${destination} = ${origin}.match(/(\\b\\d{10}\\b|\\d{2} \\d{2} \\d{2} \\d{2} \\d{2}|\\d{2}-\\d{2}-\\d{2}-\\d{2}-\\d{2}|\\(\\+\\d{2}\\)\\d{9})/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/(\\b\\d{10}\\b|\\d{2} \\d{2} \\d{2} \\d{2} \\d{2}|\\d{2}-\\d{2}-\\d{2}-\\d{2}-\\d{2}|\\(\\+\\d{2}\\)\\d{9})/g)[0];`;
          break;
        case "prix":
          safeCode    = `${destination} = ${origin}.match(/(\\d+\\.*\\,*\\d*) *(€|eu|\\$)/gi)?.[0].replace(/[^0-9.,]/gi, '') ?? '';`;
          displayCode = `${origin}.match(/(\\d+\\.*\\,*\\d*) *(€|eu|\\$)/gi)[0][1].replace(/[^0-9.,]/gi, '');`;
          break;
        default:
          safeCode    = `${destination} = ${origin}.match(/'${searchType}'/g)?.[0] ?? '';`;
          displayCode = `${destination} = ${origin}.match(/'${searchType}'/g)[0];`;
          break;
      }
    } else {
      safeCode    = `${destination} = ${origin}.match(/${args[0]}/g)?.[0] ?? '';`;
      displayCode = `${destination} = ${origin}.match(/${args[0]}/g)[0];`;
    }

    return { displayCode, safeCode };
  }
}
